<template>
  <div>
    <div id="state_dropdown" class="row" style="padding-bottom:20px">
      <div class="col-md-6">
        <select v-model="selected">
          <option value="">Filter by State</option>
          <option
            v-for="state in states"
            :key="state.name"
            :value="state.short_name"
          >
            {{ state.name }}
          </option>
        </select>
      </div>
      <div class="col-md-6 text-right">
        <h4>Total: {{ total }}</h4>
      </div>
    </div>
    <div>
      <pie-chart
        :library="chartOptions"
        :data="demographics"
        :colors="colors"
        :legend="true"
        height="400px"
        width="100%"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Chartkick from 'vue-chartkick';
import Chart from 'chart.js';
import UserClient from '@/api/UserClient';
import AdminClient from '@/api/AdminClient';

Vue.use(Chartkick.use(Chart));

export default {
    name: 'StudentByEthnicity',
    data() {
      return {
        userClient: new UserClient(this.$http),
        adminClient: new AdminClient(this.$http),
        selected: '',
        chartOptions: {
          legend: { display: true, labels: { fontColor: '#f5f5f5' } },
        },
        colors: [
        '#4cf2f0',
        '#77e9b8',
        '#9de093',
        '#c0d476',
        '#e0c567',
        '#e49b4d',
        '#e16e47',
        '#dc564b',
        '#d43d51'
        ]
      }
    },
    asyncComputed: {
      states:{
        default: [],
        async get() {
          const response = await this.userClient.getStatesList({}, 100, 0)
          if (!response || !response.results) { return [] }
          return response.results
        }
      },
      async studentByState() {
        const response = await this.adminClient.getStudentDemographics()
        if (!response || !response.results) { return [] }
        return response.results
      }
    },
    computed: {
      total() {
        if (!this.demographics) { return 0; }

        let result = 0
        for (const key of Object.keys(this.demographics)) { result += this.demographics[key] }
        return result
      },
      demographics() {
        if (!this.studentByState || !this.studentByState.length) { return { } }

        let demo = { }

        if (this.selected) {
          demo = { ...this.studentByState.find((item) => this.selected === item.state) }
        } else if (this.studentByState.length > 1) {
          demo = this.studentByState.reduce(this.aggregate_ethnicity_by_state_array)
        } else {
          demo = { ...this.studentByState[0] }
        }

        if (!demo) { return { } }
        if (demo.state) { delete demo.state; }
        if (demo.total) { delete demo.total; }

        return this.format_keys_for_chart(demo);
      }
    },
    methods: {
      aggregate_ethnicity_by_state_array(previous, current, index, arr) {
        if (!previous) { return { ...current } }

        const agg = { ...previous }

        for (const key of Object.keys(previous)) { agg[key] += current[key] }

        return agg;
      },
      format_keys_for_chart(demographics) {
        const formatted = {}
        for (const key of Object.keys(demographics)) {
          const cap_key = key[0].toUpperCase() + this.spaces_for_camel_case(key.substring(1))
          formatted[cap_key] = demographics[key]
        }

        return formatted
      },
      spaces_for_camel_case(str) {
        for (let i = 0; i < str.length; i++) {
          if (str[i] === str[i].toUpperCase()) {
            str = `${str.slice(0, i)} ${str.slice(i)}`;
            i++;
          }
        }
      return str;
      }
    }
}
</script>
<style lang="scss" scoped>

select {
  color: #6b6e88;
  border: none;
  font-weight: 500;
  font-size: 16px;
  border-radius: $border-radius;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 2px 0;
}
</style>
